/*
Copyright 2026 Element Creations Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import { useTranslation } from "react-i18next";

import { useEffect, useState } from "react";
import { THEME_EVENT, THEME_STORAGE_KEY } from "./useTheme";

export function ThemeToggle() {
  const { t } = useTranslation();
  const [light, setLight] = useState(() =>
    document.body.classList.contains("cpd-theme-light"),
  );
  useEffect(() => {
    const observer = new MutationObserver(() =>
      setLight(document.body.classList.contains("cpd-theme-light")),
    );
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);
  const label = light
    ? t("instance.theme_toggle.switch_to_dark_theme")
    : t("instance.theme_toggle.switch_to_light_theme");
  return (
    <button
      type="button"
      className="glass-button theme-toggle"
      aria-label={label}
      title={label}
      onClick={() => {
        const theme = light ? "dark" : "light";
        try {
          localStorage.setItem(THEME_STORAGE_KEY, theme);
        } catch {
          /* Theme still works without storage. */
        }
        window.dispatchEvent(new CustomEvent(THEME_EVENT, { detail: theme }));
      }}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        aria-hidden="true"
      >
        {light ? (
          <path d="M20.5 14.2A8.5 8.5 0 0 1 9.8 3.5 8.5 8.5 0 1 0 20.5 14.2Z" />
        ) : (
          <>
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2m0 16v2M2 12h2m16 0h2M4.9 4.9l1.4 1.4m11.4 11.4 1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
          </>
        )}
      </svg>
    </button>
  );
}
